<template>
  <v-sheet
    height="128"
    width="128"
    elevation="3"
    v-bind="$attrs"
    style="margin-left: 16px"
  >
    <div class="display-simulation-ka">
      <div class="text-big">5</div>
      <div class="text-small">Euro</div>
      <img style="position: absolute; top: 86px; left: 86px;" src="data:image/png;base64,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" alt="EKBO">
      <contenteditable
        tag="div"
        class="text-content"
        v-model="val"
        :contenteditable="selected && editable"
      ></contenteditable>
    </div>
  </v-sheet>
</template>

<script>
export default {
  name: 'DisplayKindKA',
  props: ["value", "selected", "editable"],
  data () {
    return {
      val: this.value
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newValue) {
        this.val = newValue
      }
    },
    val (newVal) {
      this.$emit("input", newVal)
    }
  },
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
.display-simulation-ka
  width: 128px
  height: 128px
  position: relative
  background-color: black
  color: white
  font-family: Arial
  font-size: 16px
  line-height: 100%
  overflow: hidden
  margin-right: 0

  > div
    position: relative

  .text-content
    position: absolute
    top: 51px
    text-align: center
    width: 100%
    line-height: 100%
    white-space: nowrap

  .text-big
    font-size: 48px
    position: absolute
    right: 60px
    bottom: 84px
    line-height: 100%
    margin-bottom: -3px

  .text-small
    font-size: 24px
    bottom: -22px
    left: 72px

</style>
